import { scoreClass } from "../lib/format";

export function ScoreBadge({ score, size = "md" }) {
  const sz = size === "lg" ? "h-12 w-12 text-lg" : size === "sm" ? "h-8 w-10 text-sm" : "h-10 w-12 text-base";
  return (
    <div
      data-testid={`score-badge-${score}`}
      className={`font-mono-tab ${sz} flex items-center justify-center rounded-md border-2 font-bold shadow-sm ${scoreClass(score)}`}
    >
      {score}
    </div>
  );
}
